// extracted by css-extract-rspack-plugin
export default {"subscriptionTypeName":"SubscriptionList-module__subscriptionTypeName__isFzuVc"};